import {Observable} from "rxjs/index";
import {HttpParams, HttpResponse} from "@angular/common/http";
import {AbstractPagination} from "@core/bean/abstract-pagination";


export class Pagination extends AbstractPagination {

  getOriginalData(params: HttpParams): Observable<HttpResponse<any>> {
    return this.getData(params);
  }

  getData: (params: HttpParams) => Observable<HttpResponse<any>>;

}
